import type { StepPlanInfoId, StepPlanRepetitionMode } from '@az3fr/core';

import { MultilineEditable } from '@/components/ui/multiline-editable';
import { SelectableMetricList } from '@/entities/metrics/ui/metric-list';
import { ModeSwitcher } from '@/features/workout-creator/ui/v2/step-editor-v2/components/ModeSwitcher';

interface StepPlanDetailsProps {
	stepPlanId: StepPlanInfoId;
	notes: string | null;
	onNoteChange: (notes: string | null) => void;
	repetitionMode: StepPlanRepetitionMode;
	onRepetitionModeChange: (repetitionMode: StepPlanRepetitionMode) => void;
	sectionType: string;
	sectionRounds: number | null;
	shouldShowModeSwitcher: boolean;
	isModeSwitcherDisabled: boolean;
}

export function StepPlanDetails({
	stepPlanId,
	notes,
	onNoteChange,
	repetitionMode,
	onRepetitionModeChange,
	sectionType,
	shouldShowModeSwitcher,
	isModeSwitcherDisabled,
}: StepPlanDetailsProps) {
	return (
		<div className="space-y-4 sm:space-y-5">
			<MultilineEditable
				value={notes}
				onChange={onNoteChange}
				placeholder="+&nbsp;Add a note"
				emptyValue="+&nbsp;Add a note"
			/>

			<ModeSwitcher
				repetitionMode={repetitionMode}
				onRepetitionModeChange={onRepetitionModeChange}
				shouldShow={shouldShowModeSwitcher}
				isDisabled={isModeSwitcherDisabled}
				sectionType={sectionType}
			/>

			<SelectableMetricList
				stepPlanId={stepPlanId}
				maxSelection={3}
				showMaxIndicator={true}
				label="Properties"
				className="mb-3.5"
			/>
		</div>
	);
}
